import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";

export const STAT_CARDS = [
    { key: "total", label: "Total", value: 0, icon: EventNoteOutlinedIcon, emphasize: false },
    { key: "new", label: "New", value: 0, icon: PendingActionsOutlinedIcon, emphasize: true },
    { key: "confirmed", label: "Confirmed", value: 0, icon: AccessTimeOutlinedIcon, emphasize: false },
    { key: "canceled", label: "Canceled", value: 0, icon: AssignmentTurnedInOutlinedIcon, emphasize: false },
];

export const STAT_CARD_MAP = {
    total: "Total",
    pending: "New",
    confirmed: "Confirmed",
    canceled: "Canceled",
}

export const STATUS = {
  active: { key: "active", color: "#15803D", bg: "#E7F6EC", bar: "#22C55E" },
  inactive: { key: "inactive", color: "#B91C1C", bg: "#FDEAEA", bar: "#EF4444" },
};